import useBreadcrumb from "../../core/hooks/useBreadcrumb";
import usePageTitle from "../../core/hooks/usePageTitle";
import ClienteForm from "../features/ClienteForm";

export default function ClienteCadastroView() {
  usePageTitle("Cadastro de cliente");
  useBreadcrumb("Cliente/Cadastro");
  return <ClienteForm />;
}
